import Lottie from 'lottie-react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import consultLoadingGif from '../../assets/images/consultLoading.gif';
import busLottie from '../../assets/lotties/busLottie.json';
import { useAppContext } from '../../contexts/auth';
import { useConsultsLoadingContext } from '../../contexts/consultsLoadingContext';
import useApiCall from '../../hooks/useApiCall';
import useGetGeneralAppData from '../../hooks/useGetGeneralAppData';
import { useQuery } from '../../hooks/useQuery';
import companyTokenService from '../../services/companyTokenService';
import { ConsultPresenceBadge, useConsultPresenceDetail } from '../../services/consult-presence';
import ConsultsService from '../../services/ConsultsService';
import myPlaceService from '../../services/myPlaceService';
import ReclamationsService from '../../services/ReclamationsService';
import parseCurrencyStringToFloat from '../../utils/parseCurrencyStringToFloat';
import removeDuplicates from '../../utils/removeDuplicates';
import Loader from '../Loader';
import PageHeader from '../PageHeader';
import AIModal from './components/AIModal';
import ChangeGoingOptionModal from './components/ChangeGoingOptionModal';
import ChangeReturningOptionModal from './components/ChangeReturningOptionModal';
import ConsultDataAndSettingsCard from './components/ConsultDataAndSettingsCard';
import EditDataModal from './components/EditDataModal';
import EditSettingsModal from './components/EditSettingsModal';
import ImplantationModal from './components/ImplantationModal';
import ManualRoutingModal from './components/ManualRoutingModal';
import MapDataViewModal from './components/MapDataViewModal';
import MyLinkFullModal from './components/MyLinkFullModal';
import ReclamationsModal from './components/ReclamationsModal';
import Result from './components/Result';
import { ViewType } from './components/Result/components/SidebarRoute/types';
import ResultHeader from './components/ResultHeader';
import SendMyLinkModal from './components/SendMyLinkModal';
import { DadosConsulta, DownloadDocumentsApiResponse, EnderecosLt, ErroTrajeto, GetMultiResultApiResponse, GetResultApiResponse, HistoricoReclama, IAnswerStatusOptions, IAnswerTypesOptions, IGetAnswerOptions, IWorkplacesOptions, JustificativaDesarme, LinhasBia, LinhasExcecao, MyPlaceResponse, OpBia, OpExcecao, SectionOptionType, TrajetoSelecaoIda, TrajetoSelecaoVolum, TrajetosIda, TrajetosVolum, UsuImplantacoes, ValeTransp } from './types';

interface IRoutingResult {
  returnLink: string;
  status: string;
  statusColor?: 'green' | 'orange' | 'gray' | 'red';
}

export default function RoutingResult({
  returnLink,
  status,
  statusColor,
}: IRoutingResult) {
  const [isGettingResult, setIsGettingResult] = useState(true);
  const [isWaitingResult, setIsWaitingResult] = useState(false);
  const [isSomethingLoading, setIsSomethingLoading] = useState(false);
  const [isChangingOption, setIsChangingOption] = useState(false);
  const [isSendingForRouting, setIsSendingForRouting] = useState(false);
  const [companyLabel, setCompanyLabel] = useState('');

  const [consultData, setConsultData] = useState({} as DadosConsulta);
  const [newConsultData, setNewConsultData] = useState({} as DadosConsulta);
  const [linesBias, setLinesBias] = useState([] as LinhasBia[]);
  const [opsBias, setOpsBias] = useState([] as OpBia[]);
  const [biasType, setBiasType] = useState<'P' | 'F'>('P');
  const [linesException, setLinesException] = useState([] as LinhasExcecao[]);
  const [opsException, setOpsException] = useState([] as OpExcecao[]);
  console.log(linesBias, opsBias, linesException, opsException);
  const [workplaces, setWorkplaces] = useState<EnderecosLt[]>([]);
  const [canChooseUsesAffreightment, setCanChoseUsesAffreightment] = useState(true);

  const [isConsultValid, setIsConsultValid] = useState(true);
  const [canEnableActions, setCanEnableActions] = useState(true);
  const [view, setView] = useState<ViewType>('tickets');
  const [lastRoutingDate, setLastRoutingDate] = useState<Date | null>(null);
  const [consultStatus, setConsultStatus] = useState('');
  const [routingType, setRoutingType] = useState(0);

  const [selectedWorkplaces, setSelectedWorkplaces] = useState<IWorkplacesOptions[]>([]);
  const [sectionOptions, setSectionOptions] = useState<SectionOptionType[]>([]);
  const [selectedSection, setSelectedSection] = useState<SectionOptionType>({} as SectionOptionType);
  const [allRoutes, setAllRoutes] = useState<TrajetoSelecaoIda[]>([]);
  const [goingRoute, setGoingRoute] = useState<TrajetoSelecaoIda[]>([]);
  const [returningRoute, setReturningRoute] = useState<TrajetoSelecaoVolum[]>([]);
  const [tickets, setTickets] = useState<ValeTransp[]>([]);

  const [selectedGoingRoute, setSelectedGoingRoute] = useState<TrajetosIda>({} as TrajetosIda);
  const [otherGoingOptions, setOtherGoingOptions] = useState<TrajetosIda[]>([]);
  const [otherReturningOptions, setOtherReturningOptions] = useState<TrajetosVolum[]>([]);
  const [predefinedOptions, setPredefinedOptions] = useState<TrajetosIda[]>([]);
  const [implantationDetails, setImplantationDetails] = useState({} as UsuImplantacoes);
  const [criminalRisc, setCriminalRisc] = useState('');
  const [mapUrl, setMapUrl] = useState('');
  const [routingDocumentDownloadLink, setRoutingDocumentDownloadLink] = useState('');
  const [isManualRouting, setIsManualRouting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [resultHeaderWidth, setResultHeaderWidth] = useState<number | null>(null);

  const [reclamations, setReclamations] = useState<HistoricoReclama[]>([]);
  const [reclamationsModalShow, setReclamationsModalShow] = useState(false);
  const [answerStatusOptions, setAnswerStatusOptions] = useState<IAnswerStatusOptions[]>([]);
  const [answerTypesOptions, setAnswerTypesOptions] = useState<IAnswerTypesOptions[]>([]);

  const [editConsultDataModalShow, setEditConsultDataModalShow] = useState(false);
  const [editSettingsDataModalShow, setEditSettingsDataModalShow] = useState(false);
  const [changeGoingOptionModalShow, setChangeGoingOptionModalShow] = useState(false);
  const [changeReturningOptionModalShow, setChangeReturningOptionModalShow] = useState(false);
  const [manualRoutingModalShow, setManualRoutingModalShow] = useState(false);
  const [showManualRoutingButton, setShowManualRoutingButton] = useState(false);
  const [implantationModalShow, setImplantationModalShow] = useState(false);
  const [myLinkModalShow, setMyLinkModalShow] = useState(false);

  const [routeName, setRouteName] = useState('');
  const [mapDataViewModalShow, setMapDataViewModalShow] = useState(false);

  const [lastImplantation, setLastImplantation] = useState({} as UsuImplantacoes);
  const [removalImplantationHistory, setRemovalImplantationHistory] = useState<JustificativaDesarme[]>([]);

  const [canShowMap, setCanShowMap] = useState({ going: true, returning: true });
  const [myLinkFullModalShow, setMyLinkFullModalShow] = useState(false);
  const [myLinkUrl, setMyLinkUrl] = useState('');

  const [isGettingMyPlace, setIsGettingMyPlace] = useState(false);
  const [hasCloserWorkplace, setHasCloserWorkplace] = useState(false);
  const [maxReclamations, setMaxReclamations] = useState(3);

  const [aiChatHistory, setAiChatHistory] = useState<{ role: 'user' | 'model' | 'assistant'; text: string }[]>([]);
  const [aiModalShow, setAiModalShow] = useState(false);
  const [isAiLoading, setIsAiLoading] = useState(false);
  const [aiStreamingText, setAiStreamingText] = useState('');
  const aiStreamingTextRef = useRef('');
  const streamingDoneResolverRef = useRef<(() => void) | null>(null);
  const pendingAiResultRef = useRef<{
    history?: { role: 'user' | 'model' | 'assistant'; text: string }[];
    recalculationTriggered?: boolean;
    forceManualRouting?: boolean;
  } | null>(null);
  const [canUseAiAssistant, setCanUseAiAssistant] = useState(false);
  const [aiHistoryChat, setAiHistoryChat] = useState('');

  const [particularities, setParticularities] = useState('');

  const correspondingWorkplace = useMemo(() => (workplaces.find((wp) => wp.codEndA === newConsultData.codEndA)), [newConsultData.codEndA, workplaces]);
  const isImplant = useMemo(() => !!implantationDetails?.dataUltimaImplantada, [implantationDetails?.dataUltimaImplantada]);
  const canChangeBiasType = useMemo(() => (!correspondingWorkplace?.temFretamento || !newConsultData.usaFretado), [correspondingWorkplace?.temFretamento, newConsultData.usaFretado]);

  useEffect(() => {
    const usesVtAndAffreightment = correspondingWorkplace?.temFretamento && !correspondingWorkplace?.opcaoVTFreta;
    if (usesVtAndAffreightment) {
      setBiasType('P');
    }
  }, [correspondingWorkplace, newConsultData.usaFretado]);

  const currentImplantationStatus = useMemo(() => {
    if (!isImplant) {
      return 'notImplant';
    }

    const isImplantWithVt = (lastImplantation?.funcNome || lastImplantation?.contatoNome || lastImplantation?.usuCaptaNome) && (!lastImplantation?.vtCancelado || lastImplantation.vtCancelado === 'N');
    const isImplantWithVtCanceled = (lastImplantation?.funcNome || lastImplantation?.contatoNome || lastImplantation?.usuCaptaNome) && lastImplantation?.vtCancelado && lastImplantation.vtCancelado !== 'N';

    return isImplantWithVt ? 'implant' : (isImplantWithVtCanceled ? 'implantCanceled' : 'notImplant');
  }, [lastImplantation?.contatoNome, lastImplantation?.funcNome, lastImplantation?.usuCaptaNome, lastImplantation?.vtCancelado, isImplant]);

  const intervalIdRef = useRef<null | NodeJS.Timeout>(null);
  const isFirstRender = useRef(true);

  const { consultCode } = useParams();

  useConsultPresenceDetail(consultCode);
  const { apiCall } = useApiCall();
  const navigate = useNavigate();
  const { userCode, userProfile, userName, isCustomer, services } = useGetGeneralAppData();
  const { isDifferentSubdomain } = useAppContext();
  const { addConsultToast, removeConsultToast } = useConsultsLoadingContext();
  const query = useQuery();
  const companyCode = query.get('codEmpresa');
  const activeSidebar = query.get('activeSidebar');
  const isMultiRoute = query.has('mr');
  const hasMyPlace = useMemo(() => !!((services?.some((x) => x.codServ === 17) && !isMultiRoute) || (!isCustomer && !isMultiRoute)), [services, isMultiRoute, isCustomer]);

  const selectedReturningRoute = useMemo(() => otherReturningOptions?.find((rt) => !!(rt.trajetoSelecionado)), [otherReturningOptions])!;

  const isLoading = isGettingResult || isChangingOption || isSomethingLoading || isSendingForRouting;

  const checkAiRecalculationStatus = useCallback(async (routingId: string) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_NEST_API}/gemini/recalculation-status/${routingId}`);
      const data = await response.json();

      setAiHistoryChat(data.aiHistoryChat);

      if (!isCustomer) return;

      if (!data.hasHistory) {
        setCanUseAiAssistant(true);
      } else if (data.status === 'objectionRejected') {
        setCanUseAiAssistant(false);

        if (data.rejectionReason) {
          toast.error(`Assistente IA: ${data.rejectionReason}`);
        }

        if (data.recalculationTriggered) {
          // Recálculo em andamento - o polling natural de status já está ativo
          return;
        }
      } else {
        setCanUseAiAssistant(false);
      }
    } catch (error) {
      setCanUseAiAssistant(false);
    }
  }, [isCustomer]);

  const checkIfCanShowMapByDirection = useCallback(async () => {
    const checkMapGoing = await fetch(`${process.env.REACT_APP_NEST_API}/utils/map/${consultCode}_1_1_1`);
    const checkMapReturning = await fetch(`${process.env.REACT_APP_NEST_API}/utils/map/${consultCode}_2_1_1`);

    const canShowGoing = await checkMapGoing.json();
    const canShowReturning = await checkMapReturning.json();
    setCanShowMap({ going: canShowGoing.success, returning: canShowReturning.success });
    return;
  }, [consultCode]);

  const handleViewChange = useCallback((view: ViewType) => {
    setView(view);
    if (view === 'going' || view === 'tickets') {
      if (!canShowMap.going) {
        return;
      }
      setMapUrl(selectedGoingRoute?.urlMapa);
    } else if (view === 'returning') {
      if (!canShowMap.returning) {
        if (canShowMap.going) {
          setMapUrl(selectedGoingRoute?.urlMapa);
        }
        return;
      }
      setMapUrl(selectedReturningRoute?.urlMapa);
    }
  }, [canShowMap.going, canShowMap.returning, selectedGoingRoute?.urlMapa, selectedReturningRoute?.urlMapa]);

  const getResult = useCallback(async () => {
    if (!companyCode) {
      toast.error('Não foi possível recuperar o resultado da consulta, pois não identificamos o código da empresa da mesma.');
      navigate(returnLink);
      return;
    }

    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }

    checkIfCanShowMapByDirection();

    await apiCall({
      apiToCall: isMultiRoute ? ConsultsService.getMrConsultResult : ConsultsService.getConsultResult,
      queryParams: { consultCode, codEmpresa: companyCode, codUsu: userCode, perfilUsu: userProfile },
      onStartLoad: () => setIsGettingResult(true),
      onEndLoad: () => setIsGettingResult(false),
      catchMessage: 'Não foi possível recuperar o resultado da consulta devido a um erro desconhecido',
      catchAction: () => {
        navigate(returnLink);
        return;
      },
      actionAfterResponse: isMultiRoute ?
        async (response: GetMultiResultApiResponse) => {
          const { codigo, msg } = response;
          if (!codigo) {
            toast.error(`Não foi possível recuperar o resultado da consulta ${msg}`);
            navigate(returnLink);
            return;
          }

          const { dadosConsulta, dadosConfiguracao, enderecosLT, empresa, valeTransp, riscoCriminalidade, rotManual, erroTrajetos, erroResultado, historicoReclama, usuImplantacoes, consultaValida, codUltimaConsulta, rotasTrajetos, dadosRotas, trajetosSelecionados, justificativaDesarme } = response;

          if (!consultaValida) {
            setIsConsultValid(false);
            if (codUltimaConsulta) {
              setCanEnableActions(false);
              toast.warn(<div onClick={() => navigate(`/consults/result/${codUltimaConsulta}?codEmpresa=${companyCode}&activeSidebar=${activeSidebar}&returnLink=${encodeURIComponent(returnLink)}${isMultiRoute ? '&mr' : ''}`)}>Existe uma consulta mais recente ({codUltimaConsulta}). Para realizar qualquer alteração, clique aqui para acessá-la!</div>, { autoClose: false });
              setView('going');
            } else {
              setCanEnableActions(true);
              toast.info('Esta consulta não está mais valida, portanto caso haja um reprocessamento, uma nova consulta será gerada.');
            }
          }

          setIsWaitingResult(false);
          const selectedRoute = rotasTrajetos?.find((x) => !!x.trajetoSelecionado && x.sentido === 1);

          const sectionOpts = dadosRotas?.map((x) => ({
            value: x.sequenciaTrajeto, label: `Trecho ${x.sequenciaTrajeto} (${x.tipoRotaMRDescr}) - ${x.OrigLogra} ➡️ ${x.DestLogra}`
          })) ?? [];
          const selectedScn = sectionOpts[0];
          setSectionOptions(sectionOpts);
          setSelectedSection(selectedScn);
          setRemovalImplantationHistory(justificativaDesarme);

          setLastRoutingDate(new Date(dadosConsulta.dataProcessamento));
          setCanChoseUsesAffreightment(dadosConfiguracao.usaFreta);
          setMaxReclamations(dadosConfiguracao.totalMaxReclama || 0);
          setConsultStatus(dadosConsulta.statusConsulta);
          setMapUrl(selectedRoute?.urlMapa ?? '');
          setIsManualRouting(rotManual);
          setReclamations(historicoReclama);
          setErrorMessage('');
          setRouteName(dadosRotas?.[0]?.identificacaoRota ?? '');
          setConsultData(dadosConsulta);
          setNewConsultData(dadosConsulta);
          setParticularities(dadosConfiguracao.particularidades);
          setWorkplaces(enderecosLT);
          const allWorkplacesFromSections = dadosRotas?.map((x) => {
            const correspondingWorkplace = enderecosLT?.find((y) => String(y.codEndA) === x.codEndLocTrabDestino);

            if (!correspondingWorkplace) return null;

            return correspondingWorkplace;
          })?.filter((x) => !!x) as EnderecosLt[];
          setSelectedWorkplaces(removeDuplicates(allWorkplacesFromSections.map((x) => ({ value: x.codEndA, label: x.denominacaoLT, ...x }))));
          setCompanyLabel(empresa);

          setAllRoutes(trajetosSelecionados?.map((x) => ({ ...x, sentido: x.sentido !== 2 ? 'IDA' : 'VOLTA', sequenciaTrajeto: x.sequenciaTrajeto })) ?? []);
          const routeBeingViewed = trajetosSelecionados?.filter((x) => x.sequenciaTrajeto === selectedScn?.value) ?? [];
          setGoingRoute(routeBeingViewed.map((x) => ({ ...x, sentido: x.sentido !== 2 ? 'IDA' : 'VOLTA'})));

          const returningRouteBeingViewed = trajetosSelecionados?.filter((x) => x.sentido === 2) ?? [];
          setReturningRoute(returningRouteBeingViewed.map((x) => ({ ...x, sentido: x.sentido === 1 ? 'IDA' : 'VOLTA'})));

          setTickets(valeTransp);
          setCriminalRisc(riscoCriminalidade);
          setImplantationDetails(usuImplantacoes);

          if ((!!erroTrajetos && erroTrajetos?.length > 0) || (erroResultado || !rotasTrajetos)) {
            const formatErrorMessages = (error: ErroTrajeto): string => {
              const { rota, codSentido, msgErroResultado } = error;
              const sentido = codSentido === 1 ? 'ida' : 'volta';
              return `Rota: ${rota}, sentido: ${sentido} - ${msgErroResultado}`;
            };

            const message = erroTrajetos?.length > 0 ? erroTrajetos.map(formatErrorMessages).join('\n\n') : 'Erro ao processar a consulta. Por favor, tente reprocessar.';
            setErrorMessage(message);
            return;
          }

          const trajetosIda = rotasTrajetos?.filter((x) => x.sentido !== 2)?.map((x) => ({ ...x, rota: x.codRota, sequenciaTrajeto: x.sequenciaTrajeto })) ?? [];
          const trajetosVolta = rotasTrajetos?.filter((x) => x.sentido === 2)?.map((x) => ({ ...x, rota: x.codRota, sequenciaTrajeto: x.sequenciaTrajeto })) ?? [];
          trajetosIda?.sort((a, b) => a.trajeto - b.trajeto);
          trajetosVolta?.sort((a, b) => a.trajeto - b.trajeto);
          setOtherGoingOptions(trajetosIda ?? []);
          setOtherReturningOptions(trajetosVolta ?? []);

          const unifiedGoingAndReturningOptions: TrajetosIda[] = JSON.parse(JSON.stringify([...trajetosIda, ...(trajetosVolta ? trajetosVolta : [])]));

          const optionsWithGoingAndReturningDefined = unifiedGoingAndReturningOptions.filter(rts => {
            const count: { [key: number]: number } = {};
            unifiedGoingAndReturningOptions.forEach(cur => {
              count[cur.trajeto] = (count[cur.trajeto] || 0) + 1;
            });
            return isMultiRoute ? count[rts.trajeto] === dadosRotas.length : count[rts.trajeto] === 2;
          });

          const predefinedGoingReturningOptions: TrajetosIda[] = optionsWithGoingAndReturningDefined.reduce((acc: TrajetosIda[], cur: TrajetosIda) => {
            const index = acc?.findIndex(item => item.trajeto === cur.trajeto);
            if (index !== -1) {
              acc[index].valorVtTotal += cur.valorVtTotal;
              acc[index].tempoTotTj += cur.tempoTotTj;
            } else {
              acc.push(cur);
            }
            return acc;
          }, []);
          setPredefinedOptions(predefinedGoingReturningOptions);
        }
        :
        async (response: GetResultApiResponse) => {
          const { codigo, msg } = response;
          if (!codigo) {
            toast.error(`Não foi possível recuperar o resultado da consulta ${msg}`);
            navigate(returnLink);
            return;
          }

          const { dadosConsulta, dadosConfiguracao, enderecosLT, empresa, trajetoSelecaoIda, trajetoSelecaoVolta, trajetosIda, trajetosVolta, valeTransp, riscoCriminalidade, rotManual, erroTrajetos, erroResultado, historicoReclama, linkCarta, usuImplantacoes, consultaValida, codUltimaConsulta, justificativaDesarme, tipoRoteirizacao, linhasBias, opBias, linhasExcecao, opExcecao } = response;

          if (!consultaValida) {
            setIsConsultValid(false);
            if (codUltimaConsulta) {
              setCanEnableActions(false);
              toast.warn(<div onClick={() => navigate(`/consults/result/${codUltimaConsulta}?codEmpresa=${companyCode}&activeSidebar=${activeSidebar}&returnLink=${encodeURIComponent(returnLink)}${isMultiRoute ? '&mr' : ''}`)}>Existe uma consulta mais recente ({codUltimaConsulta}). Para realizar qualquer alteração, clique aqui para acessá-la!</div>, { autoClose: false });
              setView('going');
            } else {
              setCanEnableActions(true);
              toast.info('Esta consulta não está mais valida, portanto caso haja um reprocessamento, uma nova consulta será gerada.');
            }
          }

          setIsWaitingResult(false);
          const selectedRoute = trajetosIda?.find((x) => !!x.trajetoSelecionado);

          setMyLinkUrl(`${process.env.REACT_APP_MYLINK_BASE_URL}?codEmpresa=${companyCode}&codConsulta=${consultCode}&codFuncionario=${dadosConsulta.codFuncionario}`);
          setRoutingType(tipoRoteirizacao);
          setLastRoutingDate(new Date(dadosConsulta.dataProcessamento));
          setCanChoseUsesAffreightment(dadosConfiguracao.usaFreta);
          setConsultStatus(dadosConsulta.statusConsulta);
          setMapUrl(selectedRoute?.urlMapa ?? '');
          setIsManualRouting(rotManual);
          setReclamations(historicoReclama);
          setRemovalImplantationHistory(justificativaDesarme);

          setErrorMessage('');
          setConsultData(dadosConsulta);
          setNewConsultData(dadosConsulta);
          setLinesBias(linhasBias || []);
          setOpsBias(opBias || []);
          console.log('opBias', opBias);
          console.log('linhasBias', linhasBias);
          const originalBiasType = opBias?.[0]?.tipoBias || linhasBias?.[0]?.tipoBias || 'P';
          setBiasType(originalBiasType);
          setLinesException(linhasExcecao || []);
          setOpsException(opExcecao || []);
          setWorkplaces(enderecosLT);
          setCompanyLabel(empresa);
          setGoingRoute(trajetoSelecaoIda);
          setReturningRoute(trajetoSelecaoVolta);
          setTickets(valeTransp);
          setCriminalRisc(riscoCriminalidade);
          setRoutingDocumentDownloadLink(linkCarta);
          setImplantationDetails(usuImplantacoes);
          setParticularities(dadosConfiguracao.particularidades);
          if ((!!erroTrajetos && erroTrajetos?.length > 0) || (erroResultado || !trajetosIda) || (!trajetoSelecaoVolta && !!trajetoSelecaoIda)) {
            const formatErrorMessages = (error: ErroTrajeto): string => {
              const { rota, codSentido, msgErroResultado } = error;
              const sentido = codSentido === 1 ? 'ida' : 'volta';
              return `Rota: ${rota}, sentido: ${sentido} - ${msgErroResultado}`;
            };

            const message = erroTrajetos?.length > 0 ? erroTrajetos.map(formatErrorMessages).join('\n\n') : 'Erro ao processar a consulta. Por favor, tente reprocessar.';
            setErrorMessage(message);
            return;
          }

          trajetosIda?.sort((a, b) => a.trajeto - b.trajeto);
          trajetosVolta?.sort((a, b) => a.trajeto - b.trajeto);
          setOtherGoingOptions(trajetosIda ?? []);
          setOtherReturningOptions(trajetosVolta ?? []);

          const unifiedGoingAndReturningOptions: TrajetosIda[] = JSON.parse(JSON.stringify([...trajetosIda, ...(trajetosVolta ? trajetosVolta : [])]));

          const optionsWithGoingAndReturningDefined = unifiedGoingAndReturningOptions.filter(rts => {
            const count: { [key: number]: number } = {};
            unifiedGoingAndReturningOptions.forEach(cur => {
              count[cur.trajeto] = (count[cur.trajeto] || 0) + 1;
            });
            return count[rts.trajeto] === 2;
          });

          const predefinedGoingReturningOptions: TrajetosIda[] = optionsWithGoingAndReturningDefined.reduce((acc: TrajetosIda[], cur: TrajetosIda) => {
            const index = acc?.findIndex(item => item.trajeto === cur.trajeto);
            if (index !== -1) {
              acc[index].valorVtTotal += cur.valorVtTotal;
              acc[index].tempoTotTj += cur.tempoTotTj;
            } else {
              acc.push(cur);
            }
            return acc;
          }, []);
          setPredefinedOptions(predefinedGoingReturningOptions);

          if (consultCode) {
            await checkAiRecalculationStatus(consultCode);
          }
        }
    });

    if (!isCustomer) {
      await apiCall({
        apiToCall: ReclamationsService.getAnswerStatusTypesOptions,
        queryParams: { codUsu: userCode, perfilUsu: userProfile },
        onStartLoad: () => setIsGettingResult(true),
        onEndLoad: () => setIsGettingResult(false),
        catchMessage: 'Não foi posível carregar as opções. Por favor, tente novamente',
        catchAction: () => {
          toast.error('Não foi possível carregar as opções. Por favor, tente novamente.');
          navigate(returnLink);
        },
        actionAfterResponse: (response: IGetAnswerOptions) => {
          const { codigo, msg, listaStatusResposta, listaTiposResposta } = response;
          if (!codigo) {
            toast.error(`Não foi possível carregar as opções. Por favor, tente novamente (${msg})`);
            navigate(returnLink);
            return;
          }

          setAnswerStatusOptions(listaStatusResposta ?? []);
          setAnswerTypesOptions(listaTiposResposta ?? []);
        },
      });
    }
  }, [companyCode, checkIfCanShowMapByDirection, apiCall, isMultiRoute, consultCode, userCode, userProfile, isCustomer, navigate, returnLink, activeSidebar, checkAiRecalculationStatus]);

  const checkResultStatus = useCallback(async () => {
    console.log('CHAMEI A CHECK RESULT STATUS');
    if (!companyCode) {
      toast.error('Não foi possível recuperar o resultado da consulta, pois não identificamos o código da empresa da mesma.');
      navigate(returnLink);
      return;
    }

    let isResultReady = false;

    const checkIsResultReady = async () => await apiCall({
      apiToCall: isMultiRoute ? ConsultsService.getMrConsultResult : ConsultsService.getConsultResult,
      queryParams: { consultCode, codEmpresa: companyCode, codUsu: userCode, perfilUsu: userProfile },
      actionAfterResponse: (response: GetResultApiResponse) => {
        const { codigo, msg, emProcessamento } = response;

        console.log('emProcessamento - checkIsResultReady', emProcessamento);
        if (!emProcessamento) {
          console.log('ENTREI QUE NÃO ESTÁ EM PROCESSAMENTO');
          if (!codigo) {
            toast.error(`Não foi possível recuperar o status da consulta ${consultCode} (${msg})`);
            if (intervalIdRef.current) {
              clearInterval(intervalIdRef.current);
              intervalIdRef.current = null;
            }
            navigate(returnLink);
            return true;
          }
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }
          isResultReady = true;
          console.log('isResultReady', isResultReady);
          console.log('CHAMEI GET RESULT');
          getResult();
          setIsWaitingResult(false);

          if (consultCode) {
            removeConsultToast({
              consultCode,
              companyCode,
              status: 'loading',
              resultLink: `/consult/${consultCode}?codEmpresa=${companyCode}${isMultiRoute ? '&mr' : ''}`
            });
          }
          return;
        } else {
          console.log('ENTREI QUE ESTÁ EM PROCESSAMENTO');
          if (consultCode) {
            addConsultToast({
              consultCode,
              companyCode,
              status: 'loading',
              resultLink: `/consults/result/${consultCode}?codEmpresa=${companyCode}&activeSidebar=${activeSidebar}&returnLink=${encodeURIComponent(returnLink)}${isMultiRoute ? '&mr' : ''}`,
            });
            setIsGettingResult(false);
          }
          setIsWaitingResult(true);
        }
      },
      catchAction: () => {
        toast.error(`Não foi possível recuperar o status da consulta ${consultCode}`);
        navigate(returnLink);
        return true;
      }
    });

    if (!isResultReady) {
      await checkIsResultReady();
    }

    return isResultReady;
  }, [activeSidebar, addConsultToast, apiCall, companyCode, consultCode, getResult, isMultiRoute, navigate, removeConsultToast, returnLink, userCode, userProfile]);

  const startResultStatusInterval = useCallback(async () => {
    const isResultReady = await checkResultStatus();
    console.log('RETORNO IS RESULT READY', isResultReady);
    if (isResultReady) {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
      return;
    }

    if (!intervalIdRef.current) {
      const id = setInterval(() => {
        checkResultStatus();
      }, 5000);
      intervalIdRef.current = id;
    }
  }, [checkResultStatus]);

  const handleSelectedSectionChange = useCallback(async (selectedSection: SectionOptionType) => {
    setSelectedSection(selectedSection);

    if (selectedSection?.value === sectionOptions?.length) {
      handleViewChange('returning');
    } else {
      handleViewChange('going');
    }
  }, [handleViewChange, sectionOptions?.length]);

  const changeGoingOption = useCallback(async (selectedOption: TrajetosIda) => {
    await apiCall({
      apiToCall: isMultiRoute ? ConsultsService.changeConsultOptionMr : ConsultsService.changeConsultOption,
      reqBody: isMultiRoute ? JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        codEmpresa: companyCode,
        codConsulta: consultCode,
        tipoProc: 3,
        sentido: selectedOption.sentido,
        trajeto: selectedOption.trajeto,
        codRota: selectedOption.rota,
        sequenciaTrajeto: selectedOption.sequenciaTrajeto,
      }) : JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        codEmpresa: companyCode,
        codConsulta: consultCode,
        tipoProc: 1,
        sentido: 1,
        rota: selectedOption.rota,
        trajeto: selectedOption.trajeto,
      }),
      onStartLoad: () => setIsChangingOption(true),
      onEndLoad: () => setIsChangingOption(false),
      actionAfterResponse: async (response: GetResultApiResponse) => {
        const { codigo, msg } = response;
        if (!codigo) {
          toast.error(`Não foi possível alterar para a opção selecionada ${msg}`);
          setIsGettingResult(false);
          return;
        }
        await getResult();
        setChangeGoingOptionModalShow(false);
        toast.success('A opção de ida foi alterada com sucesso. Caso queira optar pela anterior, basta selecioná-la novamente');
      }
    });
  }, [apiCall, companyCode, consultCode, getResult, isMultiRoute, userCode, userName, userProfile]);

  const changeReturningOption = useCallback(async (selectedOption: TrajetosVolum) => {
    await apiCall({
      apiToCall: isMultiRoute ? ConsultsService.changeConsultOptionMr : ConsultsService.changeConsultOption,
      reqBody: isMultiRoute ? JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        codEmpresa: companyCode,
        codConsulta: consultCode,
        tipoProc: 3,
        sentido: 2,
        trajeto: selectedOption.trajeto,
        codRota: selectedOption.rota,
        sequenciaTrajeto: selectedOption.sequenciaTrajeto,
      }) : JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        codEmpresa: companyCode,
        codConsulta: consultCode,
        tipoProc: 1,
        sentido: 2,
        rota: selectedOption.rota,
        trajeto: selectedOption.trajeto,
      }),
      onStartLoad: () => setIsChangingOption(true),
      onEndLoad: () => setIsChangingOption(false),
      actionAfterResponse: async (response: GetResultApiResponse) => {
        const { codigo, msg } = response;
        if (!codigo) {
          toast.error(`Não foi possível alterar para a opção selecionada ${msg}`);
          setIsGettingResult(false);
          return;
        }
        setChangeReturningOptionModalShow(false);
        await getResult();
        toast.success('A opção de volta foi alterada com sucesso. Caso queira optar pela anterior, basta selecioná-la novamente');
      }
    });
  }, [apiCall, companyCode, consultCode, getResult, isMultiRoute, userCode, userName, userProfile]);

  const changePredefinedOption = useCallback(async (selectedOption: TrajetosIda) => {
    await Promise.all([
      await apiCall({
        apiToCall: ConsultsService.changeConsultOption,
        reqBody: JSON.stringify({
          codUsu: userCode,
          perfilUsu: userProfile,
          usuario: userName,
          codEmpresa: companyCode,
          codConsulta: consultCode,
          tipoProc: 1,
          sentido: 1,
          rota: selectedOption.rota,
          trajeto: selectedOption.trajeto,
        }),
        onStartLoad: () => setIsChangingOption(true),
        onEndLoad: () => setIsChangingOption(false),
        actionAfterResponse: async (response: GetResultApiResponse) => {
          const { codigo, msg } = response;
          if (!codigo) {
            toast.error(`Não foi possível alterar para a opção selecionada ${msg}`);
            setIsGettingResult(false);
            return;
          }
        }
      }),
      await apiCall({
        apiToCall: ConsultsService.changeConsultOption,
        reqBody: JSON.stringify({
          codUsu: userCode,
          perfilUsu: userProfile,
          usuario: userName,
          codEmpresa: companyCode,
          codConsulta: consultCode,
          tipoProc: 1,
          sentido: 2,
          rota: selectedOption.rota,
          trajeto: selectedOption.trajeto,
        }),
        onStartLoad: () => setIsChangingOption(true),
        onEndLoad: () => setIsChangingOption(false),
        actionAfterResponse: async (response: GetResultApiResponse) => {
          const { codigo, msg } = response;
          if (!codigo) {
            toast.error(`Não foi possível alterar para a opção selecionada ${msg}`);
            setIsGettingResult(false);
            return;
          }
        }
      }),
    ]);
    toast.success(`A alteração para a opção ${selectedOption.trajeto} foi concluída com sucesso.`);
    await getResult();
  }, [apiCall, companyCode, consultCode, getResult, userCode, userName, userProfile]);

  const sendForRouting = useCallback(async () => {
    const routingSequence = [];

    const hasHomeAddress = newConsultData.bairro && newConsultData.cidade && newConsultData.uf && newConsultData.cep && newConsultData.logradouro && newConsultData.num;

    let lat = newConsultData.lat;
    let lng = newConsultData.lng;

    const hasCoords = lat && lng;

    if (!hasHomeAddress) {
      toast.warn('Por favor, preencha o endereço residencial para que possamos roteirizar. Inclusive as coordenadas, que podem ser buscadas automaticamente.');
      return;
    }

    if (!hasCoords && hasHomeAddress) {
      const geolocationByAddress = await fetch(
        `${process.env.REACT_APP_NEST_API}/maps-proxy/geocode?address=${newConsultData.logradouro} ${newConsultData.num} ${newConsultData.bairro} ${newConsultData.cidade} ${newConsultData.uf} ${newConsultData.cep}`,
      );
      const responseJson = await geolocationByAddress.json();

      const geometryLocation = responseJson.results[0]?.geometry.location ?? {
        lat: 0,
        lng: 0,
      };

      lat = geometryLocation.lat;
      lng = geometryLocation.lng;
    }

    if (!lat || !lng) {
      toast.error('Não foi possível obter as coordenadas do endereço residencial. Por favor, preencha manualmente, ou tente realizar a busca automática pelo botão de buscar as coordenadas.');
      return;
    }

    if (isMultiRoute) {
      const firstElement = {
        codConsulta: consultCode,
        codMultiRotas: otherGoingOptions[0]?.codMultiRotas,
        codRota: 1,
        identificacaoRota: routeName,
        sequenciaTrajeto: 1,
        tipoRotaMR: 1,
        codEndLocTrabOrigem: '',
        codEndLocTrabDestino: String(selectedWorkplaces[0].codEndA),
      };
      routingSequence.push(firstElement);

      const restElements = selectedWorkplaces.map((wp, index) => ({
        codConsulta: consultCode,
        codMultiRotas: otherGoingOptions[0]?.codMultiRotas,
        codRota: 1,
        identificacaoRota: routeName,
        sequenciaTrajeto: index + 2,
        tipoRotaMR: (index === selectedWorkplaces.length - 1 ? 3 : 2),
        codEndLocTrabOrigem: String(wp.codEndA),
        codEndLocTrabDestino: index === selectedWorkplaces.length - 1 ? '' : String(selectedWorkplaces[index + 1].codEndA),
      }));
      routingSequence.push(...restElements);

      const isFirstElementValid = !!routingSequence[0].codEndLocTrabDestino;
      const isLastElementValid = !!routingSequence[routingSequence.length - 1].codEndLocTrabOrigem;
      const areMiddleElementsValid = routingSequence.slice(1, routingSequence.length - 1).every((x) => !!x.codEndLocTrabOrigem && !!x.codEndLocTrabDestino);
      const isSequenceValid = isFirstElementValid && isLastElementValid && areMiddleElementsValid;

      if (!isSequenceValid) {
        toast.error('Sequência de locais de trabalho inválida. Por favor, revise os locais selecionados.');
        return;
      }
    }

    !isMultiRoute ? await apiCall({
      apiToCall: ConsultsService.sendForRouting,
      reqBody: JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        codEmpresa: companyCode,
        tipoRot: 3,
        servico: 2,
        nomeArquivoImp: '',
        dadosRoteirizar: [{
          ...newConsultData,
          logradouro: newConsultData.logradouro.slice(0, 50),
          lat,
          lng,
          gestaoSaldo: false,
          codEndAlpha: '',
          nomeArquivoImp: '',
          valorTeto: (typeof newConsultData.valorTeto === 'string' ? parseCurrencyStringToFloat(newConsultData.valorTeto) || 0 : newConsultData.valorTeto || 0),
          valorVT: (typeof newConsultData.valorVT === 'string' ? parseCurrencyStringToFloat(newConsultData.valorVT) || 0 : newConsultData.valorVT || 0),
          opcaoVTFreta: correspondingWorkplace?.opcaoVTFreta || false,
          temLinhasBias: linesBias.length > 0,
          temOpBias: opsBias.length > 0,
          temLinhasExcecao: linesException.length > 0,
          temOpExcecao: opsException.length > 0,
          linhasExcecao: linesException.length > 0 ? linesException : null,
          opExcecao: opsException.length > 0 ? removeDuplicates(opsException.map((op) => ({ ...op, codOperadora: Number(String(op.codOperadora).replaceAll('PV_', ''))}))) : null,
          linhasBias: linesBias.length > 0 ? linesBias : null,
          opBias: opsBias.length > 0 ? removeDuplicates(opsBias.map((op) => ({ ...op, codOperadora: Number(String(op.codOperadora).replaceAll('PV_', ''))}))) : null
        }],
      }),
      onStartLoad: () => setIsSendingForRouting(true),
      onEndLoad: () => setIsSendingForRouting(false),
      actionAfterResponse: (response) => {
        if (!response.codigo) {
          toast.error(`Não foi possível roteirizar. Por favor, tente novamente (${response.msg})`);
          return;
        }

        const consultCodeAtResponse = response.codConsulta;
        const isNewConsult = consultCodeAtResponse != consultCode;

        if (isNewConsult) {
          toast.info('Uma nova consulta foi gerada pois esta não está mais válida.');
          navigate(`/consults/result/${consultCodeAtResponse}?codEmpresa=${companyCode}&activeSidebar=${activeSidebar}&returnLink=${encodeURIComponent(returnLink)}`);
          return;
        }

        startResultStatusInterval();
      }
    }) : await apiCall({
      apiToCall: ConsultsService.sendForMultiRouting,
      reqBody: JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        codEmpresa: companyCode,
        tipoRot: 7,
        servico: 2,
        nomeArquivoImp: '',
        dadosRoteirizarMR: [{
          ...newConsultData,
          lat,
          lng,
          codEndA: selectedWorkplaces[0].codEndA,
          codEndAlpha: selectedWorkplaces[0].codEndNoclienteAlfaN,
          reprocessaTodos: true,
          rotaRelacionada: 0,
          gestaoSaldo: false,
          nomeArquivoImp: '',
          valorVT: 0,
          valorTeto: 0,
          // valorTeto: (typeof newConsultData.valorTeto === 'string' ? parseCurrencyStringToFloat(newConsultData.valorTeto) : newConsultData.valorTeto),
          // valorVTIdeal: (typeof newConsultData.valorVTIdeal === 'string' ? parseCurrencyStringToFloat(newConsultData.valorVTIdeal) : newConsultData.valorVTIdeal),
          usaEspelhamento: false,
          usaFretado: false,
          rotasMR: routingSequence,
          rotasMRArq: [],
          opcaoVTFreta: correspondingWorkplace?.opcaoVTFreta || false,
        }],
      }),
      onStartLoad: () => setIsSendingForRouting(true),
      onEndLoad: () => setIsSendingForRouting(false),
      actionAfterResponse: (response) => {
        if (!response.codigo) {
          toast.error(`Não foi possível roteirizar. Por favor, tente novamente (${response.msg})`);
          return;
        }

        const consultCodeAtResponse = response.codConsulta;
        const isNewConsult = consultCodeAtResponse != consultCode;

        if (isNewConsult) {
          toast.info('Uma nova consulta foi gerada pois esta não está mais válida.');
          navigate(`/consults/result/${consultCodeAtResponse}?codEmpresa=${companyCode}&activeSidebar=${activeSidebar}&returnLink=${encodeURIComponent(returnLink)}`);
          return;
        }

        startResultStatusInterval();
      }
    });

  }, [activeSidebar, apiCall, companyCode, consultCode, correspondingWorkplace?.opcaoVTFreta, isMultiRoute, linesBias, linesException, navigate, newConsultData, opsBias, opsException, otherGoingOptions, returnLink, routeName, selectedWorkplaces, startResultStatusInterval, userCode, userName, userProfile]);

  const getMyPlace = useCallback(async () => {
    const { logradouro, num, cep, bairro, cidade, uf, lat, lng } = newConsultData;
    const isFullAddressFilled = logradouro && num && cep && bairro && cidade && uf && lat && lng;
    if (!hasMyPlace || !correspondingWorkplace?.codEnd || !isFullAddressFilled) return;

    try {
      setIsGettingMyPlace(true);
      let token = '';
      await apiCall({
        apiToCall: companyTokenService.getCompanyToken,
        queryParams: { companyId: companyCode as string },
        actionAfterResponse: (response) => {
          token = response.token || '';
        },
        catchMessage: 'Houve um erro ao carregar o token da empresa',
        catchAction() {
          token = '';
        },
      });

      if (!token) return;

      await apiCall({
        apiToCall: myPlaceService.getMyPlaceData,
        queryParams: { token },
        reqBody: JSON.stringify({
          streetName: newConsultData.logradouro,
          streetNumber: newConsultData.num,
          zipCode: newConsultData.cep,
          district: newConsultData.bairro,
          city: newConsultData.cidade,
          uf: newConsultData.uf,
          desirableDistance: 30000,
        }),
        actionAfterResponse: (response: MyPlaceResponse) => {
          if (!response.success) return;

          const admissionRadarWorkplaces = response.admissionRadarWorkplaces;
          const selectedWorkplaceDistance = admissionRadarWorkplaces.find((workplace) => workplace.captaId === correspondingWorkplace?.codEnd)?.distance || 0;
          setHasCloserWorkplace(admissionRadarWorkplaces.some((workplace) => workplace.distance < selectedWorkplaceDistance));

          setWorkplaces((prevWorkplaces) => {
            const mappedWorkplaces = admissionRadarWorkplaces.map((workplace) => {
              const wp = prevWorkplaces.find((wp) => wp.codEnd === workplace.captaId);
              return {
                ...wp,
                distanceFromEmployeeHome: workplace.distance,
              } as EnderecosLt;
            }).filter((wp) => wp.codEnd !== undefined);

            const missingWorkplaces = prevWorkplaces.filter((wp) => !admissionRadarWorkplaces.some((workplace) => workplace.captaId === wp.codEnd));
            return [...mappedWorkplaces, ...missingWorkplaces];
          });
        },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsGettingMyPlace(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiCall, companyCode, correspondingWorkplace?.codEnd, hasMyPlace, newConsultData.bairro, newConsultData.cep, newConsultData.cidade, newConsultData.logradouro, newConsultData.num, newConsultData.uf]);

  useEffect(() => {
    if (hasMyPlace) {
      getMyPlace();
    }
  }, [getMyPlace, hasMyPlace]);

  const downloadMrRoutingDocument = useCallback(async () => {
    await apiCall({
      apiToCall: ConsultsService.downloadManyDocuments,
      reqBody: JSON.stringify({
        codEmpresa: companyCode,
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        tipoCarta: 2,
        consultas: [{ codConsulta: consultCode }],
      }),
      onStartLoad: () => setIsSomethingLoading(true),
      onEndLoad: () => setIsSomethingLoading(false),
      actionAfterResponse: (response: DownloadDocumentsApiResponse) => {
        if (!response.codigo) {
          toast.error(`Não foi possível fazer o download da carta. Por favor, tente novamente (${response.msg})`);
          return;
        }

        const documentInfo = response.consults[0];
        if (!documentInfo || !documentInfo.consult) {
          toast.error('Não foi possível fazer o download da carta. Por favor, tente novamente');
          return;
        }

        const endpoint = `CartaMR.aspx?temp=${response.consults[0].consult}`;

        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_REL_BASE_URL}/${endpoint}`;
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.info('Seu download foi iniciado (Verifique na parte de downloads em seu navegador');
      }
    });
  }, [apiCall, companyCode, consultCode, userCode, userName, userProfile]);

  const handleCloseMyLinkFullModal = useCallback(async () => {
    setMyLinkFullModalShow(false);
    await getResult();
  }, [getResult]);

  useEffect(() => {
    if (!intervalIdRef.current) {
      startResultStatusInterval();
    }

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const slctGoingRoute = [...otherGoingOptions, ...otherReturningOptions]?.find((rt) => !!(rt.trajetoSelecionado) && (!rt.sequenciaTrajeto || rt.sequenciaTrajeto === selectedSection?.value));
    console.log('sasdasd', slctGoingRoute);
    setMapUrl(slctGoingRoute?.urlMapa || '');
    setSelectedGoingRoute(slctGoingRoute || {} as TrajetosIda);

    if (!isMultiRoute) {
      return;
    }

    setGoingRoute(allRoutes.filter((x) => x.sequenciaTrajeto === selectedSection?.value));
    setReturningRoute(allRoutes.filter((x) => x.sequenciaTrajeto === selectedSection?.value));
  }, [allRoutes, otherGoingOptions, selectedGoingRoute?.urlMapa, selectedSection?.value, otherReturningOptions, isMultiRoute]);

  useEffect(() => {
    if (isImplant) {
      setLastImplantation(implantationDetails);
    }
  }, [implantationModalShow, currentImplantationStatus, isImplant, lastImplantation, implantationDetails]);

  const lastReclamation = useMemo(() => ((reclamations?.[(reclamations?.length ?? 0) - 1]?.reclamacao) || ''), [reclamations]);

  const handleObjectionStream = useCallback(async (
    userMessage: string,
    currentHistory: { role: 'user' | 'model' | 'assistant'; text: string }[],
  ) => {
    const initResponse = await fetch(`${process.env.REACT_APP_NEST_API}/gemini/handle-objection/stream/init`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        routingId: Number(consultCode),
        companyId: Number(companyCode),
        history: [...currentHistory, { role: 'user', text: userMessage }],
      }),
    });

    if (!initResponse.ok) {
      throw new Error('SSE init request failed');
    }

    const { streamId } = await initResponse.json() as { streamId: string };

    let hasReceivedChunk = false;

    return new Promise<{
      history?: { role: 'user' | 'model' | 'assistant'; text: string }[];
      recalculationTriggered?: boolean;
      forceManualRouting?: boolean;
      messageToUser?: string;
      hasStreamingContent: boolean;
    }>((resolve, reject) => {
      const es = new EventSource(`${process.env.REACT_APP_NEST_API}/gemini/handle-objection/stream/${streamId}`);

      es.onmessage = (ev) => {
        const parsed = JSON.parse(ev.data) as {
          event: string;
          text?: string;
          messageToUser?: string;
          history?: { role: 'user' | 'model' | 'assistant'; text: string }[];
          recalculationTriggered?: boolean;
          forceManualRouting?: boolean;
          message?: string;
        };
        if (parsed.event === 'chunk') {
          hasReceivedChunk = true;
          setAiStreamingText((prev) => {
            const next = prev + (parsed.text || '');
            aiStreamingTextRef.current = next;
            return next;
          });
        } else if (parsed.event === 'result') {
          es.close();
          resolve({ ...parsed, hasStreamingContent: hasReceivedChunk });
        } else if (parsed.event === 'error') {
          es.close();
          aiStreamingTextRef.current = '';
          setAiStreamingText('');
          reject(new Error(parsed.message || 'SSE error'));
        }
      };

      es.onerror = (err) => {
        es.close();
        aiStreamingTextRef.current = '';
        setAiStreamingText('');
        reject(err);
      };
    });
  }, [consultCode, companyCode]);

  const sendMessageToAI = useCallback(async (
    userMessage: string,
    currentHistory: { role: 'user' | 'model' | 'assistant'; text: string }[],
    retryCount = 0,
  ): Promise<{ success: true; data: {
    history?: { role: 'user' | 'model' | 'assistant'; text: string }[];
    recalculationTriggered?: boolean;
    forceManualRouting?: boolean;
    messageToUser?: string;
    hasStreamingContent: boolean;
  } } | { success: false; error: unknown }> => {
    try {
      const useGeminiStream = process.env.REACT_APP_USE_GEMINI_STREAM === 'true';

      let data;
      if (useGeminiStream) {
        data = await handleObjectionStream(userMessage, currentHistory);
      } else {
        const response = await fetch(`${process.env.REACT_APP_NEST_API}/gemini/handle-objection`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            routingId: Number(consultCode),
            companyId: Number(companyCode),
            history: [...currentHistory, { role: 'user', text: userMessage }],
          }),
        });

        if (!response.ok) {
          throw new Error('API request failed');
        }

        data = await response.json() as {
          history?: { role: 'user' | 'model' | 'assistant'; text: string }[];
          recalculationTriggered?: boolean;
          forceManualRouting?: boolean;
          messageToUser?: string;
          hasStreamingContent?: boolean;
        };
      }

      return { success: true, data: { ...data, hasStreamingContent: (data as { hasStreamingContent?: boolean }).hasStreamingContent ?? false } };
    } catch (error) {
      if (retryCount < 2) {
        await new Promise((resolve) => { setTimeout(resolve, 5000); });
        return sendMessageToAI(userMessage, currentHistory, retryCount + 1);
      }
      toast.error('Não foi possível se comunicar com o assistente. Por favor, tente novamente.');
      return { success: false, error };
    }
  }, [consultCode, companyCode, handleObjectionStream]);

  const applyAiResult = useCallback(async (data: {
    history?: { role: 'user' | 'model' | 'assistant'; text: string }[];
    recalculationTriggered?: boolean;
    forceManualRouting?: boolean;
  }) => {
    const updatedHistory = data.history || [];
    setAiChatHistory(updatedHistory);

    if (data.recalculationTriggered) {
      const recalculationMessage = {
        role: 'model' as const,
        text: 'Entendi os pontos que você mencionou! Vou recalcular seu resultado de acordo com o que conversamos. Aguarde um momento enquanto processo as alterações... 🔄',
      };
      setAiChatHistory([...updatedHistory, recalculationMessage]);
      await new Promise((resolve) => { setTimeout(resolve, 6000); });
      startResultStatusInterval();
      setAiChatHistory([]);
      setAiModalShow(false);
      setCanUseAiAssistant(false);
    }

    if (data.forceManualRouting) {
      const manualRoutingMessage = {
        role: 'model' as const,
        text: 'Vou abrir o quadro para inserir manualmente os bilhetes desta roteirização. Só um momento...',
      };
      setAiChatHistory([...updatedHistory, manualRoutingMessage]);
      await new Promise((resolve) => { setTimeout(resolve, 6000); });
      setManualRoutingModalShow(true);
      setShowManualRoutingButton(true);
    }
  }, [startResultStatusInterval]);

  const handleStreamingDone = useCallback(() => {
    setAiStreamingText('');
    setIsAiLoading(false);
    if (pendingAiResultRef.current) {
      applyAiResult(pendingAiResultRef.current);
      pendingAiResultRef.current = null;
    }
    if (streamingDoneResolverRef.current) {
      streamingDoneResolverRef.current();
      streamingDoneResolverRef.current = null;
    }
  }, [applyAiResult]);

  const handleAiMessage = useCallback(async (userMessage: string) => {
    const useGeminiStream = process.env.REACT_APP_USE_GEMINI_STREAM === 'true';

    const newUserMessage = { role: 'user' as const, text: userMessage };
    const updatedHistory = [...aiChatHistory, newUserMessage];
    setAiChatHistory(updatedHistory);

    setIsAiLoading(true);
    const result = await sendMessageToAI(userMessage, aiChatHistory);

    if (!result.success) {
      setAiStreamingText('');
      setIsAiLoading(false);
      setAiChatHistory(aiChatHistory);
      setAiModalShow(false);
      return;
    }

    if (useGeminiStream && result.data) {
      // Se não houve streaming (apenas event result), aplica resultado imediatamente
      if (!result.data.hasStreamingContent) {
        await applyAiResult(result.data);
        setIsAiLoading(false);
        return;
      }

      pendingAiResultRef.current = result.data;
      if (!aiStreamingTextRef.current) {
        const seedText = result.data.messageToUser || '';
        if (!seedText) {
          await applyAiResult(result.data);
          setIsAiLoading(false);
          pendingAiResultRef.current = null;
          return;
        }
        aiStreamingTextRef.current = seedText;
        setAiStreamingText(seedText);
      }
      // Timeout de segurança: se o streaming não completar em 30s, força o fim
      const streamingTimeout = new Promise<void>((_, reject) => {
        setTimeout(() => reject(new Error('Streaming timeout')), 30000);
      });
      const streamingPromise = new Promise<void>((resolve) => {
        streamingDoneResolverRef.current = resolve;
      });
      try {
        await Promise.race([streamingPromise, streamingTimeout]);
      } catch {
        // Timeout atingido, aplica resultado mesmo assim
        aiStreamingTextRef.current = '';
        setAiStreamingText('');
        if (pendingAiResultRef.current) {
          await applyAiResult(pendingAiResultRef.current);
          pendingAiResultRef.current = null;
        }
      } finally {
        setIsAiLoading(false);
      }
    } else if (result.data) {
      await applyAiResult(result.data);
      setIsAiLoading(false);
    } else {
      setIsAiLoading(false);
    }
  }, [aiChatHistory, sendMessageToAI, applyAiResult]);

  const handleOpenAdjustmentModal = useCallback(() => {
    if (canUseAiAssistant && isCustomer && !reclamations?.length) {
      setAiModalShow(true);
    } else {
      setReclamationsModalShow(true);
    }
  }, [canUseAiAssistant, isCustomer, reclamations?.length]);

  return (
    <>
      <Loader isLoading={isLoading} />
      <PageHeader
        title={(
          <>
            {`Consulta ${consultCode}`}
            {consultCode && <ConsultPresenceBadge consultCode={consultCode} />}
          </>
        )}
        link={returnLink}
        status={status}
        statusColor={statusColor || 'gray'}
        statusRot={consultData.statusRoteirizacao}
      />

      {!isGettingResult && (
        <>
          {!isWaitingResult && (
            <>
              <ConsultDataAndSettingsCard
                consultData={consultData}
                workplaces={workplaces}
                companyCode={companyCode ?? ''}
                company={companyLabel}
                criminalRisc={criminalRisc}
                setEditConsultDataModalShow={setEditConsultDataModalShow}
                setEditSettingsDataModalShow={setEditSettingsDataModalShow}
                selectedWorkplaces={selectedWorkplaces}
                isMultiRoute={isMultiRoute}
                routeName={routeName}
                routingType={routingType}
                linesBias={linesBias}
                opsBias={opsBias}
                linesException={linesException}
                opsException={opsException}
                isGettingMyPlace={isGettingMyPlace}
                hasCloserWorkplace={hasCloserWorkplace}
                hasMyPlace={hasMyPlace}
                particularities={particularities}
              />

              <ResultHeader
                setHeaderWidth={setResultHeaderWidth}
                lastRoutingDate={lastRoutingDate}
                consultStatus={consultStatus}
                lastImplantationDate={implantationDetails?.dataUltimaImplantada}
                isImplant={isImplant}
                sendForRouting={sendForRouting}
                routingDocumentDownloadLink={routingDocumentDownloadLink}
                setImplantationModalShow={setImplantationModalShow}
                handleOpenAdjustmentModal={handleOpenAdjustmentModal}
                setManualRoutingModalShow={setManualRoutingModalShow}
                setMyLinkModalShow={setMyLinkModalShow}
                canEnableActions={canEnableActions}
                isConsultValid={isConsultValid}
                setMapDataViewModalShow={setMapDataViewModalShow}
                downloadMrRoutingDocument={downloadMrRoutingDocument}
                isMultiRoute={isMultiRoute}
                implantationStatus={currentImplantationStatus}
                lastReclamation={lastReclamation}
                showManualRoutingButton={showManualRoutingButton}
              />

              <Result
                goingRoute={goingRoute}
                returningRoute={returningRoute}
                mapUrl={mapUrl}
                resultHeaderWidth={resultHeaderWidth}
                otherGoingOptions={otherGoingOptions}
                otherReturningOptions={otherReturningOptions}
                handleViewChange={handleViewChange}
                view={view}
                setChangeGoingOptionModalShow={setChangeGoingOptionModalShow}
                setChangeReturningOptionModalShow={setChangeReturningOptionModalShow}
                tickets={tickets}
                predefinedOptions={predefinedOptions}
                selectedGoingRoute={selectedGoingRoute}
                selectedReturningRoute={selectedReturningRoute}
                changePredefinedOption={changePredefinedOption}
                isManualRouting={isManualRouting}
                errorMessage={errorMessage}
                setIsSomethingLoading={setIsSomethingLoading}
                canShowTicketsTab={canEnableActions}
                canEnableActions={canEnableActions}
                isConsultValid={isConsultValid}
                handleSelectedSectionChange={handleSelectedSectionChange}
                sectionOptions={sectionOptions}
                selectedSection={selectedSection}
                isMultiRoute={isMultiRoute}
                allRoutes={allRoutes}
                statusRot={consultData.statusRoteirizacao}
                finalValue={Number(consultData.valorVTIdeal)}
                canShowMap={canShowMap.going}
                setMyLinkFullModalShow={setMyLinkFullModalShow}
              />

              <ChangeGoingOptionModal
                changeGoingOptionModalShow={changeGoingOptionModalShow}
                otherGoingOptions={otherGoingOptions}
                setChangeGoingOptionModalShow={setChangeGoingOptionModalShow}
                selectedGoingRoute={selectedGoingRoute}
                changeGoingOption={changeGoingOption}
                setIsLoading={setIsSomethingLoading}
                selectedSection={selectedSection}
                isMultiRoute={isMultiRoute}
              />

              <ChangeReturningOptionModal
                changeReturningOptionModalShow={changeReturningOptionModalShow}
                otherReturningOptions={otherReturningOptions}
                setChangeReturningOptionModalShow={setChangeReturningOptionModalShow}
                selectedReturningRoute={selectedReturningRoute}
                changeReturningOption={changeReturningOption}
                setIsLoading={setIsSomethingLoading}
                isMultiRoute={isMultiRoute}
                selectedSection={selectedSection}
              />

              <EditDataModal
                editConsultDataModalShow={editConsultDataModalShow}
                setEditConsultDataModalShow={setEditConsultDataModalShow}
                setIsSomethingLoading={setIsSomethingLoading}
                consultData={consultData}
                setConsultData={setConsultData}
                newConsultData={newConsultData}
                setNewConsultData={setNewConsultData}
                workplaces={workplaces}
                companyLabel={companyLabel}
                canEnableActions={canEnableActions}
                isMultiRoute={isMultiRoute}
                selectedWorkplaces={selectedWorkplaces}
                setSelectedWorkplaces={setSelectedWorkplaces}
                routeName={routeName}
                setRouteName={setRouteName}
                setOpsBias={setOpsBias}
                setLinesBias={setLinesBias}
              />

              <EditSettingsModal
                editSettingsDataModalShow={editSettingsDataModalShow}
                setEditSettingsDataModalShow={setEditSettingsDataModalShow}
                consultData={consultData}
                setConsultData={setConsultData}
                newConsultData={newConsultData}
                setNewConsultData={setNewConsultData}
                canChooseUsesAffreightment={canChooseUsesAffreightment}
                routingType={routingType}
                linesBias={linesBias}
                setLinesBias={setLinesBias}
                opsBias={opsBias}
                setOpsBias={setOpsBias}
                linesException={linesException}
                setLinesException={setLinesException}
                opsException={opsException}
                setOpsException={setOpsException}
                isMultiRoute={isMultiRoute}
                setIsSomethingLoading={setIsSomethingLoading}
                biasType={biasType}
                setBiasType={setBiasType}
                canChangeBiasType={canChangeBiasType}
              />

              <ReclamationsModal
                reclamationsModalShow={reclamationsModalShow}
                handleCloseReclamationsModal={() => setReclamationsModalShow(false)}
                reclamations={reclamations}
                setIsLoading={setIsSomethingLoading}
                answerStatusOptions={answerStatusOptions}
                answerTypesOptions={answerTypesOptions}
                loadResult={() => getResult()}
                canEnableActions={canEnableActions}
                companyCode={companyCode!}
                employeeMail={newConsultData.mail}
                maxReclamations={maxReclamations}
                aiHistoryChat={aiHistoryChat}
              />

              <ManualRoutingModal
                manualRoutingModalShow={manualRoutingModalShow}
                setManualRoutingModalShow={setManualRoutingModalShow}
                setIsLoading={setIsSomethingLoading}
                getResult={getResult}
                isMultiRoute={isMultiRoute}
              />

              <ImplantationModal
                implantationModalShow={implantationModalShow}
                setImplantationModalShow={setImplantationModalShow}
                setIsLoading={setIsSomethingLoading}
                implantation={implantationDetails}
                isImplant={!!implantationDetails?.dataUltimaImplantada}
                getResult={getResult}
                currentImplantationStatus={currentImplantationStatus}
                removalImplantationHistory={removalImplantationHistory}
              />

              <SendMyLinkModal
                email={newConsultData.mail}
                myLinkModalShow={myLinkModalShow}
                setMyLinkModalShow={setMyLinkModalShow}
                setIsLoading={setIsSomethingLoading}
                getResult={getResult}
              />

              <MapDataViewModal
                mapDataViewModalShow={mapDataViewModalShow}
                setMapDataViewModalShow={setMapDataViewModalShow}
                consultCode={consultCode ?? ''}
                setIsLoading={setIsSomethingLoading}
              />

              <MyLinkFullModal
                myLinkFullModalShow={myLinkFullModalShow}
                handleCloseMyLinkFullModal={() => handleCloseMyLinkFullModal()}
                myLinkUrl={myLinkUrl}
              />

              <AIModal
                handleAiMessage={handleAiMessage}
                aiChatHistory={aiChatHistory}
                isAiLoading={isAiLoading}
                setAiModalShow={setAiModalShow}
                aiModalShow={aiModalShow}
                streamingText={aiStreamingText}
                onStreamingDone={handleStreamingDone}
              />
            </>
          )}

          {isWaitingResult && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {isDifferentSubdomain && <Lottie animationData={busLottie} loop={true} />}
              {!isDifferentSubdomain && <img src={consultLoadingGif} alt="" />}
            </div>
          )}
        </>
      )}
    </>
  );
}
